import React from "react";
import { GameParams } from "../../../validation/game-params";
import { createIntl } from "react-intl";

import { generateLocaleStyle } from "../../../utils/generate-locale-style";

import { TabView } from "./view";
import { DefaultLocale } from "inbox-contentful";
import { Loading } from "../../../components/loading";
import { ErrorBoundary } from "../../../components/error-boundary";

export const TabController = ({
    children,
    data,
    locale,
    userSettings,
}: {
    children: typeof React.Children;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    locale: LocaleSettings;
    userSettings: GameParams;
}) => {
    if (!data) {
        return <Loading primary />;
    }

    const style = generateLocaleStyle(locale);

    const { globals } = data;

    const intl = createIntl({
        locale: locale.lang ?? DefaultLocale,
        messages: globals as Record<string, string>,
    });

    const props = {
        children,
        data,
        intl,
        locale,
        style,
        userSettings,
    };

    return (
        <ErrorBoundary>
            <TabView {...props} />
        </ErrorBoundary>
    );
};
